import { createContext, useContext } from "react";
import type { Config, Sale } from "./data";

export type AppData = { me: Sale | undefined; sales: Sale[]; config: Config; salesById: Map<number, Sale> };
export const AppContext = createContext<AppData | null>(null);

export function useApp(): AppData {
  const v = useContext(AppContext);
  if (!v) throw new Error("useApp outside <AppContext>");
  return v;
}
